import { useTranslation } from 'react-i18next';
import Clock from 'assets/img/icons/clock.svg?react';
import classNames from 'classnames';
import { format } from 'date-fns';

import s from './styles.module.scss';

import type { IKeyNoteData } from 'infrastructure/interfaces';

interface IProps {
  note: IKeyNoteData;
}
export const TemporaryNote = ({ note }: IProps) => {
  if (!note?.expiresAt) return <></>;
  const { expiresAt } = note;
  const { t } = useTranslation();
  const currDate = new Date();
  const noteDate = new Date(expiresAt);
  const formattedDate = format(noteDate, 'dd-MM-yyyy');
  const isExpired = currDate > noteDate;
  return (
    <div
      data-expired={isExpired}
      className={classNames(
        s.flex,
        s['justify-between'],
        s['note-temporary-label'],
      )}
    >
      <div className={classNames(s.flex, s['gap-5'], s['vertical-center'])}>
        <Clock height={18} width={18} />
        <p className={s['label-text']}>
          {isExpired ? t('labels.expired') : t('labels.temporaryNote')}
        </p>
      </div>
      <p className={s['label-text']}>
        {t('labels.expirationDate')} {formattedDate}
      </p>
    </div>
  );
};
